export const language = {
	title: 'Use Cases',
};
